import React, { Component } from 'react'
import './add-question.scss'
import SessionCache from '../../routes/session-cache'
import { getImageSource } from '../../../utility/image-source'
import { Constants, ImageConstants } from '../../../constants/constants'
import { Modal, ModalBody } from 'reactstrap'
import MasterDataApi from '../../../apis/master-data'
import CWCustomCKEditor from '../../common/cw-custom-ck-editor/cw-custom-ck-editor'
import CommonUtils from '../../../utility/common-utilities'
import QuestionSetApi from '../../../apis/question-set'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

const QUESTION_TYPES = [
  {
    title: 'SINGLE STEP',
    value: 1
  },
  {
    title: 'MULTI STEP',
    value: 2
  }
]
const QUESTION_SELECT_TYPES = [
  {
    title: 'SINGLE SELECT',
    value: 1
  },
  {
    title: 'MULTIPLE SELECT',
    value: 2
  }
]
const OPTIONS = [
  {
    isCorrect: false,
    content: ''
  },
  {
    isCorrect: false,
    content: ''
  }
]
const DEFAULT_STEP_VALUE = {
  content: '',
  options: OPTIONS,
  questionSelectType: QUESTION_SELECT_TYPES[0]
}
class AddQuestion extends Component {
  state = {
    activeTabIndex: 0,
    classes: [],
    chapterList: [],
    showAddQuestion: false,
    options: OPTIONS,
    content: '',
    questionSelectType: QUESTION_SELECT_TYPES[0],
    questionType: QUESTION_TYPES[0],
    steps: [DEFAULT_STEP_VALUE],
    complexityList: [],
    mark: 1,
    stepInvalid: false,
    isInvalid: false
  }

  accessRights = SessionCache.getAllowedModule()
  user = SessionCache.getUser()

  constructor (props) {
    super(props)
    this.state.selectedChapters = this.props.chapters
    if (this.state.selectedChapters?.length) {
      this.state.chapter = this.state.selectedChapters[0]
    } else {
      this.state.chapter = this.props.chapter
    }
    this.state.selectedClassName = this.props.className
    const selectedQuestion = this.props.question
    this.state.selectedQuestion = selectedQuestion
    if (selectedQuestion) {
      if (selectedQuestion.content.isMultiStep) {
        const steps = []
        selectedQuestion.content.steps.forEach(step => {
          steps.push({
            content: step.content.title,
            options: step.content.options ? step.content.options.map(o => {
              return {
                ...o,
                content: o.content.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ")
              }
            })  : [],
            typeName: step.content.typeName,
            type: step.content.type
          })
        })
        this.state.questionContent = selectedQuestion.content.title
        this.state.mark = selectedQuestion.content.mark
        this.state.complexity = {
          value: selectedQuestion.content.complexityId,
          title: selectedQuestion.content.complexity
        }
        console.log(this.state.complexity)
        this.state.isWorkingImageCheked = selectedQuestion.mandatoryAttachments
          ?.image
          ? true
          : false
        this.state.steps = steps
        this.state.questionType = QUESTION_TYPES[1]
      } else {
        this.state.content = selectedQuestion.content.title
        this.state.mark = selectedQuestion.content.mark
        this.state.complexity = {
          value: selectedQuestion.content.complexityId,
          title: selectedQuestion.content.complexity
        }
        this.state.options = selectedQuestion.content.options ? selectedQuestion.content.options.map(o => {
          return {
            ...o,
            content: o.content.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ")
          }
        }) :[]
        this.state.questionSelectType = {
          title: selectedQuestion.content.typeName,
          value: selectedQuestion.content.type
        }
        this.state.isWorkingImageCheked = selectedQuestion.mandatoryAttachments
          ?.image
          ? true
          : false
      }
    }
    this.getPracticeQuestionComplexity()
  }

  getPracticeQuestionComplexity = _ => {
    const { complexity } = this.state
    QuestionSetApi.getPracticeQuestionComplexity({})
      .then(response => {
        const complexityList = []
        response.map(res => {
          if (res.title !== 'HOTS') {
            complexityList.push({
              value: res._id,
              title: res.title
            })
          }
        })
        this.setState({
          complexityList,
          complexity: complexity?.value ? complexity : complexityList[0]
        }, _ => {
          console.log(this.state.complexity)
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  addOptions = _ => {
    const { options } = this.state
    options.push({ isCorrect: false, content: '' })
    this.setState({
      options
    })
  }

  removeOption = index => {
    const { options } = this.state
    options.splice(index, 1)
    this.setState({
      options
    })
  }

  showAddStep = _ => {
    let { steps } = this.state
    this.setState({
      onlyStep: true,
      stepIndex: steps.length,
      content: '',
      options: [
        {
          isCorrect: false,
          content: ''
        },
        {
          isCorrect: false,
          content: ''
        }
      ],
      questionSelectType: QUESTION_SELECT_TYPES[0]
    })
  }

  closeAddStep = _ => {
    let { steps } = this.state
    this.setState({
      onlyStep: false
    })
  }

  onStepEdit = index => {
    const { steps } = this.state
    const step = steps[index]
    this.setState({
      onlyStep: true,
      stepIndex: index,
      content: step.content,
      options: step.options,
      questionSelectType: {
        title: step.typeName,
        value: step.type
      },
      mark: step.content.mark
    })
  }

  onSelectNormal = (option, key) => {
    let { steps } = this.state
    this.setState(
      { [key]: option },
      _ => {
        if (key === 'selectedClassName') this.getChapterList(option)
        if (key === 'questionType') {
          if (option.value === 2) steps = []
          if (option.value === 1) steps = [DEFAULT_STEP_VALUE]
          this.setState(
            {
              steps
            },
            _ => {
              this.checkValidState()
            }
          )
        }
      },
      _ => {
        this.checkValidState()
      }
    )
  }

  onSelectStep = (option, key, index) => {
    const { options } = this.state
    this.setState(
      { [key]: option },
      _ => {
        this.checkValidState()
        if (key === 'complexity') {
          const mark = CommonUtils.getMarkByComplexity(option?.title)
          this.setState(
            {
              mark
            },
            _ => {
              this.checkValidState()
            }
          )
        }
        if (key === 'questionSelectType') {
          options.forEach(opt => {
            opt.isCorrect = false
            return opt
          })
          this.setState(
            {
              options
            },
            _ => {
              this.checkValidState()
            }
          )
        }
      }
    )
  }

  getChapterList = className => {
    if (!className) return
    const payload = {
      class: className
    }
    MasterDataApi.getChapterList(payload)
      .then(response => {
        const chapterList = []
        if (response.data.chapters && response.data.chapters.length) {
          response.data.chapters.forEach(chapter => {
            chapterList.push({
              title: chapter.title,
              value: chapter.key
            })
          })
        }
        this.setState({
          chapterList
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onPasteEvent = event => {
    if (event.data.dataValue.includes(Constants.CW_GLOSSARY)) {
      event.data.dataValue = ''
      return
    }

    if (event.data.dataValue.includes(Constants.CUSTOM_MATH_TAG)) {
      let parsedContent = CommonUtils.cwMathParsar(event)

      if (parsedContent) event.data.dataValue = parsedContent

      return
    }

    event.data.dataValue = CommonUtils.cleanHtmlOnPaste(
      event.data.dataValue,
      true
    )
  }

  onCorrectChange = (e, index) => {
    const { questionSelectType, options } = this.state
    if (questionSelectType?.value === 1) {
      options.forEach((option, idx) => {
        if (index !== idx) {
          option.isCorrect = false
        }
        return option
      })
    }
    options[index].isCorrect = !options[index].isCorrect
    this.setState(
      {
        options
      },
      _ => {
        this.checkValidState()
      }
    )
  }

  onAnswerChange = (e, index) => {
    const { options } = this.state
    options[index].content = e.target.value
    this.setState(
      {
        options
      },
      _ => {
        this.checkValidState()
      }
    )
  }

  checkValidState = _ => {
    const {
      questionType,
      options,
      questionSelectType,
      content,
      chapter,
      selectedClassName,
      steps,
      questionContent,
      complexity,
      mark,
      isWorkingImageCheked,
      onlyStep
    } = this.state
    if (onlyStep) {
      let payload = {
        questionType,
        type: questionSelectType?.value,
        typeName: questionSelectType?.title,
        options: options.map(option => {
          return {
            isCorrect: option.isCorrect,
            content: option.content,
            contentType: 1,
            contentTypeName: 'TEXT',
            id: CommonUtils.getMilliSeconds()
          }
        }),
        content: content,
        chapterId: chapter?.value,
        class: selectedClassName
      }
      this.validateStepPayload(payload, true)
    } else {
      let payload = {
        questionType,
        questionContent,
        isMultiStep: questionType?.value === 2 ? true : false,
        steps: questionType?.value === 2 ? steps : this.getSingleSteps(),
        chapterId: chapter?.value,
        class: selectedClassName,
        complexityId: complexity?.value,
        complexity: complexity?.title,
        mark: mark || CommonUtils.getMarkByComplexity(complexity?.title),
        mandatoryAttachments: {
          image: isWorkingImageCheked,
          video: false,
          audio: false
        }
      }
      console.log("Check Validate State")
      this.validatePayload(payload, true)
    }
  }

  validateStepPayload = (payload, dontShowErrorMessage) => {
    let isInvalid = true

    let invalidAnswer = false
    let correctAnswer = 0
    payload.options.forEach(option => {
      if (!option.content) invalidAnswer = true
      if (option.isCorrect) correctAnswer++
    })

    if (correctAnswer < 1) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please select minimum of one correct answer'
        })
      }
      isInvalid = false
    }
    if (invalidAnswer) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please add alteast two answers'
        })
      }
      isInvalid = false
    }
    if (!payload.type || !payload.typeName) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please select question type'
        })
      }
      isInvalid = false
    }
    if (!payload.content) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please enter question'
        })
      }
      isInvalid = false
    }
    if (isInvalid) {
      this.setState({
        errorMessage: '',
      })
    }
    this.setState({
      isInvalid
    })
    return isInvalid
  }

  saveStep = _ => {
    const {
      questionType,
      options,
      questionSelectType,
      content,
      chapter,
      selectedClassName,
      steps,
      stepIndex,
      complexity
    } = this.state
    const payload = {
      questionType,
      type: questionSelectType?.value,
      typeName: questionSelectType?.title,
      options: options.map(option => {
        return {
          isCorrect: option.isCorrect,
          content: option.content,
          contentType: 1,
          contentTypeName: 'TEXT',
          id: CommonUtils.getMilliSeconds()
        }
      }),
      content: content,
      chapterId: chapter?.value,
      class: selectedClassName
    }
    const isValid = this.validateStepPayload(payload)
    if (!isValid) return
    steps[stepIndex] = {
      type: payload?.type,
      typeName: payload?.typeName,
      options: payload?.options,
      content: payload?.content
    }
    this.setState({
      steps,
      onlyStep: false
    }, _ => {
      console.log(this.state.complexity)
      this.checkValidState()
    })
  }

  validatePayload = (payload, dontShowErrorMessage) => {
    let isInvalid = true

    payload.steps.forEach((step, index) => {
      let invalidAnswer = false
      let correctAnswer = 0
      step.options.forEach(option => {
        if (!option.content) invalidAnswer = true
        if (option.isCorrect) correctAnswer++
      })

      if (invalidAnswer) {
        if (!dontShowErrorMessage) {
          this.setState({
            errorMessage: 'Please enter answers'
          })
        }
        isInvalid = false
      }
      if (correctAnswer < 1) {
        if (!dontShowErrorMessage) {
          this.setState({
            errorMessage: 'Please select minimum of one correct answer'
          })
        }
        isInvalid = false
      }
      if (!step.type || !step.typeName) {
        if (!dontShowErrorMessage) {
          this.setState({
            errorMessage: 'Please select question type'
          })
        }
        isInvalid = false
      }
      if (!step.content) {
        if (!dontShowErrorMessage) {
          this.setState({
            errorMessage: 'Please enter question'
          })
        }
        isInvalid = false
      }
    })

    if (payload.questionType.value === 1 && payload.steps.length < 1) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please add alteast one step'
        })
      }
      isInvalid = false
    }
    if (payload.questionType.value === 2 && payload.steps.length < 2) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please add alteast two steps'
        })
      }
      isInvalid = false
    }

    if (payload.questionType.value === 2 && !payload.questionContent) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please enter question'
        })
      }
      isInvalid = false
    }

    if (!payload.complexity || !payload.mark) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please select compleixty'
        })
      }
      isInvalid = false
    }

    if (!payload.questionType) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please Select Step'
        })
      }
      isInvalid = false
    }

    if (!payload.chapterId) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please Select Chapter'
        })
      }
      isInvalid = false
    }

    if (!payload.class) {
      if (!dontShowErrorMessage) {
        this.setState({
          errorMessage: 'Please Select Class'
        })
      }
      isInvalid = false
    }

    if (isInvalid === true) {
      this.setState({
        errorMessage: ''
      })
    }
    this.setState({
      stepInvalid: isInvalid
    })
    console.log("Check Validate State", isInvalid)
    return isInvalid
  }

  getSingleSteps = _ => {
    const { options, content, questionSelectType, complexity } = this.state
    const steps = []
    steps.push({
      content: content,
      options: options.map(option => {
        return {
          isCorrect: option.isCorrect,
          content: "<p>" + option.content + "</p>",
          contentType: 1,
          contentTypeName: 'TEXT',
          id: CommonUtils.getMilliSeconds()
        }
      }),
      type: questionSelectType.value,
      typeName: questionSelectType.title
    })
    return steps
  }

  resetState = _ => {
    this.setState({
      isSubmit: false,
      showAddQuestion: false,
      selectedQuestion: null,
      content: '',
      options: [
        {
          isCorrect: false,
          content: ''
        },
        {
          isCorrect: false,
          content: ''
        }
      ],
      questionSelectType: {
        title: 'SINGLE SELECT',
        value: 1
      },
      questionType: {
        title: 'SINGLE STEP',
        value: 1
      }
    })
  }

  saveQuestionSet = _ => {
    let {
      questionType,
      steps,
      chapter,
      selectedClassName,
      selectedQuestion,
      questionContent,
      complexity,
      mark,
      isWorkingImageCheked
    } = this.state
    console.log(steps, questionType)
    const multiSteps = []
    if(questionType?.value === 2 && steps.length > 0) {
      steps.forEach((step, index) => {
        if(step.options.length > 0) {
          step.options.forEach((option, oindex) => {
            step.options[oindex] = {
              ...option,
              content: "<p>" + option.content + "</p>",
            }
          })
        }
        multiSteps.push(step)
      })
    }
    console.log(JSON.stringify(multiSteps))
    const payload = {
      questionType,
      questionContent,
      isMultiStep: questionType?.value === 2 ? true : false,
      steps: questionType?.value === 2 ? multiSteps : this.getSingleSteps(),
      chapterId: chapter?.value,
      class: selectedClassName,
      complexityId: complexity?.value,
      complexity: complexity?.title,
      mark: mark || CommonUtils.getMarkByComplexity(complexity?.title),
      mandatoryAttachments: {
        image: isWorkingImageCheked,
        video: false,
        audio: false
      }
    }

    const isValid = this.validatePayload(payload)
    if (!isValid) return
    this.setState({
      isSubmit: true
    })
    if (selectedQuestion && selectedQuestion._id) {
      payload._id = selectedQuestion._id
      QuestionSetApi.updateQuestion(payload)
        .then(response => {
          this.setState(
            {
              isSubmit: false,
              showAddQuestion: false,
              selectedQuestion: null,
              steps: [DEFAULT_STEP_VALUE],
              isWorkingImageCheked: false
            },
            _ => {
              this.props.addQuestionsSuccess(false, true)
            }
          )
        })
        .catch(err => {
          if (err?.response?.data?.code === 11000) {
            this.props.addQuestionsSuccess(false, false, 11000)
            this.setState({
              isSubmit: false
            })
          } else {
            this.setState({
              isSubmit: false
            })
          }
        })
    } else {
      QuestionSetApi.createQuestionSet(payload)
        .then(response => {
          this.setState(
            {
              isSubmit: false,
              showAddQuestion: false,
              selectedQuestion: null,
              content: '',
              options: [
                {
                  isCorrect: false,
                  content: ''
                },
                {
                  isCorrect: false,
                  content: ''
                }
              ],
              questionSelectType: {
                title: 'SINGLE SELECT',
                value: 1
              },
              questionType: {
                title: 'SINGLE STEP',
                value: 1
              },
              isWorkingImageCheked: false
            },
            _ => {
              const question = response.data.question || {}
              this.props.addQuestionsSuccess(true, false, null, question)
            }
          )
        })
        .catch(err => {
          if (err?.response?.data?.code === 11000) {
            this.props.addQuestionsSuccess(false, false, 11000)
            this.setState({
              isSubmit: false
            })
          } else {
            this.setState({
              isSubmit: false
            })
          }
        })
    }
  }

  toggleSampleQuestion = _ => {
    this.setState({
      showExampleQuestion: !this.state.showExampleQuestion
    })
  }

  toggleQuestionOptions = _ => {
    if (this.state.selectedChapters?.length > 1) {
      this.setState({
        openQuestionOptions: !this.state.openQuestionOptions
      })
    }
  }

  onSelectChapter = chapter => {
    this.setState(
      {
        chapter,
        openQuestionOptions: false
      },
      _ => {
        this.checkValidState()
      }
    )
  }

  showConfirmModal = (item, index) => {
    let deleteMessage = `Are you sure want to delete the step ${index + 1}`
    this.setState({
      deleteItem: item,
      deleteIndex: index,
      showConfirmModal: true,
      deleteMessage
    })
  }

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false })
  }

  removeStep = _ => {
    const { steps, deleteIndex } = this.state
    steps.splice(deleteIndex, 1)
    this.setState({
      steps,
      showConfirmModal: false
    })
  }

  render = _ => {
    const {
      showExampleQuestion,
      selectedClassName,
      chapter,
      questionType,
      errorMessage,
      steps,
      onlyStep,
      questionContent,
      complexityList,
      complexity,
      mark,
      isWorkingImageCheked,
      openQuestionOptions,
      selectedChapters,
      isInvalid,
      stepInvalid
    } = this.state
    return (
      <Modal
        className='cw-custom-modal question-bank-add'
        isOpen={true}
        toggle={this.props.hideAddQuestion}
        size={'xl'}
      >
        <ModalBody>
          {!showExampleQuestion && (
            <>
              <div className='row'>
                <div className='col text-right'>
                  <img
                    className='close-icon cursor-pointer'
                    onClick={_ =>
                      !onlyStep
                        ? this.props.hideAddQuestion()
                        : this.closeAddStep()
                    }
                    src={getImageSource(ImageConstants.CROSS)}
                  />
                </div>
              </div>
              <div className='pl-5 pr-5'>
                {!onlyStep && (
                  <>
                    <div className='header-text'>
                      <span>Add new Question</span>
                    </div>
                    <div className='description'>
                      <span onClick={this.toggleQuestionOptions}>
                        {selectedClassName}, {chapter?.title}
                        {selectedChapters?.length > 1 && (
                          <span className='dropdown-icn'>
                            <FontAwesomeIcon
                              icon={
                                openQuestionOptions ? faAngleUp : faAngleDown
                              }
                            />
                          </span>
                        )}
                      </span>
                      {openQuestionOptions && (
                        <div className='add-question-options'>
                          <div className='text-right'>
                            <img
                              className='close-icn'
                              onClick={this.toggleQuestionOptions}
                              src={getImageSource(ImageConstants.CROSS)}
                            />
                          </div>
                          {selectedChapters.map((chapter, index) => (
                            <div
                              className='option cursor-pointer'
                              onClick={_ =>
                                this.onSelectChapter(chapter, 'chapter')
                              }
                            >
                              {chapter.title}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className='mt-4'>
                      <div className='row class-container'>
                        {QUESTION_TYPES.map((q, index) => (
                          <div
                            key={index}
                            onClick={_ =>
                              this.onSelectNormal(q, 'questionType')
                            }
                            className={`class-title question-type cursor-pointer py-2 mr-4 ${questionType.value ===
                              q.value && 'class-active'}`}
                          >
                            {q.title}
                          </div>
                        ))}
                        {questionType.value === 2 && (
                          <div
                            className='col stem-question-example cursor-pointer'
                            onClick={this.toggleSampleQuestion}
                          >
                            <img
                              className='action-icn'
                              src={getImageSource(ImageConstants.TREE_LINE_ICN)}
                            />
                            MULTI STEP QUESTION EXAMPLE
                          </div>
                        )}
                      </div>
                      <div className='note-text'>
                        {questionType.value === 1 ? 
                          "This question will be a one step question" :
                          "This question will have multiple sub-questions"}
                      </div>
                    </div>
                    <div className='mt-4'>
                      <div className='row class-container'>
                        <div className='col-4'>
                          <label>Assign Complexity</label>
                          <div>
                            {complexityList?.length && (
                              <Dropdown
                                text='title'
                                placeholder='Select Complexity'
                                options={complexityList}
                                onSelect={option =>
                                  this.onSelectStep(option, 'complexity')
                                }
                                value={complexity?.value}
                                containerStyle={{
                                  background: '#F6F7F5',
                                  'border-radius': '5px',
                                  border: '1px solid #B5B3B3'
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className='col-4'>
                          <label>Assign Marks</label>
                          <div>
                            <div className='input-box with-borders'>
                              <input
                                placeholder='Enter Mark'
                                value={mark}
                                type='number'
                                min={1}
                                onChange={e =>
                                  this.onSelectStep(e.target.value, 'mark')
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className='col-4 working-image'>
                          <div
                            className={`name checkbox-alignment ${
                              isWorkingImageCheked ? 'active' : ''
                            }`}
                            onClick={() =>
                              this.onSelectStep(
                                !isWorkingImageCheked,
                                'isWorkingImageCheked'
                              )
                            }
                          >
                            <div className='custom-checkbox'>
                              {isWorkingImageCheked ? (
                                <div className='tick-mark'></div>
                              ) : (
                                ''
                              )}
                            </div>
                            <span className='chekbox-title'>
                              Capture students working
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {questionType?.value === 2 && (
                      <>
                        <div className='mt-4'>
                          <label>Enter Stem Question</label>
                          <div className='row class-container'>
                            <div
                              className={`custom-option-editor ${!questionContent &&
                                this.props.onSubmit &&
                                'is-invalid'}`}
                            >
                              <CWCustomCKEditor
                                content={questionContent}
                                onChange={(content, event) => {
                                  content = content.replace(/(\r\n|\n|\r)/gm, "");
                                  this.onSelectNormal(
                                    content,
                                    'questionContent'
                                  )
                                  }
                                }
                                // type={'inline'}

                                height={100}
                                autoGrow={true}
                                disableResize={true}
                                toolbar={Constants.TOOLBAR}
                                onPaste={this.onPasteEvent}
                                placeholder='Enter your Question'
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {questionType.value === 1 && this.getFields()}
                    {questionType.value === 2 &&
                      steps.map((step, index) => (
                        <div className='class-container'>
                          <div className='steps row'>
                            <div className='question-left col-9'>
                              <div className='question-text'>
                                {index + 1}.{' '}
                                {step.content.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ")}
                              </div>
                            </div>
                            <div className='question-right col-3 text-right'>
                              {/* <span className='question-score'>
                            Marks: {step.mark}
                          </span> */}
                              <img
                                className='add-icn action-icn cursor-pointer'
                                src={getImageSource(ImageConstants.EDIT)}
                                onClick={_ => this.onStepEdit(index)}
                              />
                              <img
                                tree-line-icn
                                className='add-icn action-icn cursor-pointer'
                                src={getImageSource(ImageConstants.DELETE_RED)}
                                onClick={_ =>
                                  this.showConfirmModal(step, index)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    {questionType.value === 2 && (
                      <div className='row class-container add-step'>
                        <button
                          className={`cw-button-primary cw-button-disabled add-options add-step`}
                          onClick={_ => this.showAddStep()}
                        >
                          <img
                            className='add-icon'
                            src={getImageSource(ImageConstants.ADD_BLUE)}
                          />{' '}
                          Add Branch Questions
                        </button>
                        <div className='note-text'>
                          NOTE: Min. 2 Steps are mandatory
                        </div>
                      </div>
                    )}
                  </>
                )}
                {onlyStep && this.getFields()}
                <div className='row class-container'>
                  <div className='col mt-4'>
                    {errorMessage && (
                      <div className='text-danger pb-4'>
                        <strong>{errorMessage} </strong>
                      </div>
                    )}
                    <button
                      className={`cw-button-primary ${
                        ((!onlyStep && !stepInvalid) || (onlyStep && !isInvalid)) ? 'cw-button-disabled' : ''
                      }`}
                      onClick={_ =>
                        onlyStep ? this.saveStep() : this.saveQuestionSet()
                      }
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          {showExampleQuestion && (
            <div className='px-5'>
              <div className='header-text mb-4 mt-4'>
                <span>Multi Step Question Example</span>
              </div>
              <div className='sample-question'>
                <img
                  src={getImageSource(ImageConstants.STEM_QUESTION_EXAMPLE)}
                />
              </div>
              <div className='row class-container text-center'>
                <div className='col mt-4'>
                  {errorMessage && (
                    <div className='text-danger pb-4'>
                      <strong>{errorMessage} </strong>
                    </div>
                  )}
                  <button
                    className={`cw-button-primary`}
                    onClick={this.toggleSampleQuestion}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
          {this.state.showConfirmModal && (
            <CWConfirm
              modal={this.state.showConfirmModal}
              close={this.hideConfirmModal}
              message={this.state.deleteMessage}
              onOk={this.removeStep.bind(this)}
            />
          )}
        </ModalBody>
      </Modal>
    )
  }

  getFields = () => {
    const {
      content,
      options,
      questionSelectType,
      complexity,
      complexityList,
      questionType,
      questionContent
    } = this.state
    return (
      <>
        {questionType?.value === 2 && (
          <>
            <div className='mt-4 pb-4 stem-question-container'>
              <label className='highlight'>Stem Question</label>
              <div className='row class-container'>
                <div
                  className={`custom-option-editor ${!questionContent &&
                    this.props.onSubmit &&
                    'is-invalid'}`}
                >
                  <CWCustomCKEditor
                    content={questionContent}
                    onChange={(content, event) =>{
                      content = content.replace(/(\r\n|\n|\r)/gm, "");
                      this.onSelectNormal(content, 'questionContent')
                    }
                    }
                    // type={'inline'}
                    height={100}
                    autoGrow={true}
                    disableResize={true}
                    toolbar={Constants.TOOLBAR}
                    onPaste={this.onPasteEvent}
                    placeholder='Enter your Question'
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <div className='mt-4'>
          <div className='mb-2'>
            <label className='highlight'>
              Add {questionType?.value === 2 ? 'Branch ' : ''}Question
            </label>
          </div>
          <label>
            Enter {questionType?.value === 2 ? 'Branch ' : ''}Question
          </label>
          <div className='row class-container'>
            <div
              className={`custom-option-editor ${!content &&
                this.props.onSubmit &&
                'is-invalid'}`}
            >
              <CWCustomCKEditor
                content={content}
                onChange={(content, event) =>{
                  content = content.replace(/(\r\n|\n|\r)/gm, "");
                  this.onSelectStep(content, 'content')
                }
                }
                // type={'inline'}
                height={100}
                autoGrow={true}
                disableResize={true}
                toolbar={Constants.TOOLBAR}
                onPaste={this.onPasteEvent}
                placeholder={`Enter ${
                  questionType?.value === 2 ? 'Branch ' : ''
                }Question`}
              />
            </div>
          </div>
        </div>
        <div className='mt-4'>
          <label>Answer Options</label>
          <div className='choice-options'>
            {QUESTION_SELECT_TYPES.map((q, qsIndex) => (
              <div
                className={`checkbox-container mr-2 ${
                  questionSelectType?.value === q.value ? 'active' : ''
                }`}
              >
                <div
                  className='checkbox'
                  onClick={e => this.onSelectStep(q, 'questionSelectType')}
                >
                  {questionSelectType?.value === q.value && (
                    <div className='checked'></div>
                  )}
                </div>
                <div className='correct-text d-inline-block'>
                  {q.title === 'SINGLE SELECT'
                    ? 'Only 1 Answer is correct'
                    : 'Multiple Answers are correct'}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='mt-2'>
          <div className='row class-container'>
            {options.map((option, oIndex) => (
              <div key={oIndex} className='option-container'>
                <div
                  className={`checkbox-container with-bottom-border px-2 ${
                    option.isCorrect ? 'active' : ''
                  } ${
                    questionSelectType?.value === 1
                      ? 'single-choice'
                      : 'multi-choice'
                  }`}
                >
                  <div
                    className='checkbox'
                    onClick={e => this.onCorrectChange(e, oIndex)}
                  >
                    {option.isCorrect && <div className='checked'></div>}
                  </div>
                  <div className='correct-text d-inline-block'>Correct</div>
                </div>
                <div className='input-box mt-2 px-2'>
                  <input
                    placeholder='Enter Answer option'
                    value={option.content}
                    onChange={e => this.onAnswerChange(e, oIndex)}
                  />
                </div>
                {oIndex > 1 && (
                  <div
                    className='cursor-pointer'
                    onClick={_ => this.removeOption(oIndex)}
                  >
                    <img
                      className='close-icon option-delete'
                      src={getImageSource(ImageConstants.DELETE_RED)}
                    />
                  </div>
                )}
              </div>
            ))}
            <div className='add-options-btn'>
              <button
                className={`cw-button-primary cw-button-disabled add-options`}
                onClick={_ => this.addOptions()}
              >
                <img
                  className='add-icon'
                  src={getImageSource(ImageConstants.ADD_BLUE)}
                />{' '}
                ADD OPTIONS
              </button>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default AddQuestion
